<form [formGroup]="form" class="update-form" data-testid="risk-update-form">
  <div class="label">Probability:</div>
  <app-toggle-buttons [parentFormGroup]="form" controlName="probability" [buttonLabels]="levels" [compact]="true" testIdPrefix="prob-" (valueChange)="form.markAsDirty()" class="block mb-[16px]" />
  <div class="label">Impact:</div>
  <app-toggle-buttons [parentFormGroup]="form" controlName="impact" [buttonLabels]="levels" [compact]="true" testIdPrefix="impact-" (valueChange)="form.markAsDirty()" class="block mb-[16px]" />
  @if (changed) {
    <div class="delta flex flex-row items-center gap-[8px] mb-[16px]" data-testid="score-delta">
      <app-risk-score-chip [score]="risk.score" />
      <span class="arrow">→</span>
      <app-risk-score-chip [score]="newScore" [trend]="trend" />
      <span class="text-type-14">{{ trend === 'same' ? 'Score unchanged' : 'Score goes ' + trend }}</span>
    </div>
  }
  <app-text-area [parentFormGroup]="form" controlName="comment" label="Comment" [maxLength]="4000" class="block w-full mb-[20px]" />
  <app-pictures-section-with-tags
    (onDelete)="removeFile($event)"
    [add]="true"
    [pictures]="files"
    [tags]="attachmentTag"
    [allowVideo]="false"
    [accept]="attachmentAccept"
    class="pictures-section block mb-[16px]"
    label="Attachments:"
    data-testid="update-attach"
  />
  <div class="actions flex flex-row gap-[16px] mt-[24px]">
    <app-secondary-button (handleClick)="cancelled.emit()" class="flex-1" data-testid="update-cancel">Cancel</app-secondary-button>
    <app-primary-button (handleClick)="save()" [isDisabled]="form.invalid || saving" [isLoading]="saving" class="flex-1" data-testid="update-save">Save update</app-primary-button>
  </div>
</form>
